// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "div[data-v-23e31293]{font-weight:700;padding:10px 40px;border:1.5px solid var(--color-text);border-radius:2rem;display:flex;justify-content:center;transition:background-color .2s ease-in-out,color .2s ease-in-out}div[data-v-23e31293]:hover{color:var(--color-background);background-color:var(--color-text)}", ""]);
// Exports
module.exports = exports;
